import { CourseCard } from '@/widgets/CourseCard';
import type { IStudentAboutStaffCourseItem } from '@/entities/Staff';
import { Section } from '@/shared/ui/Section';
import styles from './StaffCourses.module.scss';

interface StaffCoursesProps {
  courses: IStudentAboutStaffCourseItem[];
}

export const StaffCourses = ({ courses }: StaffCoursesProps) => (
  <Section typeSection="section" className="flex flex-col gap-y-6">
    <h2 className="text-[32px] font-medium">Courses</h2>
    <div className={styles.grid}>
      {courses.map((course) => (
        <CourseCard
          key={course.id}
          course={{
            id: course.id,
            previewImg: course.image,
            image: course.image,
            type: course.type ?? '',
            title: course.title,
            rate: null,
            leadTeacher: course?.leadTeacher ?? null,
            price: 0,
          }}
        />
      ))}
    </div>
  </Section>
);
